import type { ReactNode } from 'react';

import InfoPopover from '@/components/InfoPopover';
import { Text } from '@/components/typography';
import { cn } from '@/lib/utils';

type PanelHeaderProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  infoPopover?: {
    title?: ReactNode;
    body: ReactNode;
  };
  actions?: ReactNode;
  headerClassName?: string | false;
  actionsClassName?: string | false;
};

const PanelHeader = ({
  title,
  subtitle,
  infoPopover,
  actions,
  headerClassName = '',
  actionsClassName = '',
}: PanelHeaderProps) => (
  <div
    className={cn(
      'flex flex-row items-start justify-between gap-4 px-5 py-4',
      actions ? 'pe-4' : '',
      headerClassName,
    )}
  >
    <div className="min-w-0 flex-1">
      <Text
        className="flex items-center gap-1 leading-6 uppercase"
        variant="label"
        weight="regular"
      >
        {title}
        {infoPopover && <InfoPopover title={infoPopover.title ?? title} body={infoPopover.body} />}
      </Text>
      {subtitle && (
        <Text variant="body2" color="grey" className="mt-1 block">
          {subtitle}
        </Text>
      )}
    </div>
    {actions && (
      <div className={cn('flex max-h-6 shrink-0 items-center gap-1', actionsClassName)}>
        {actions}
      </div>
    )}
  </div>
);

export default PanelHeader;
